import { sanitizeAddress } from 'services/query/hooks'

export const getParamsForIndexDailyStat = (address: string) => (now: number) => {
  return INDEX_DAILY_STATS(address, now)
}

const INDEX_DAILY_STATS = (address: string, offset: number): string => {
  return `
      query {
        indexes(where: { id: "${sanitizeAddress(address)}" }) {
          dailyStats(orderBy: date, orderDirection: desc,where: {date_lt:${offset}}) {
            basePrice
            basePriceETH
            date
            apy
          }
        }
      }
    `
}

export const getParamsForHistoricalIndexAssets = (address: string) => (now: number) => {
  return HISTORICAL_INDEX_ASSETS(address, now)
}

const HISTORICAL_INDEX_ASSETS = (address: string, offset: number): string => {
  const offsetParams = `where: {timestamp_gt:${offset}}`
  return `
  query {
    indexes(where: { id: "${sanitizeAddress(address)}" }) {
      id
      chainID
      history(orderBy: timestamp, orderDirection: asc,${offsetParams}) {
        assets {
         asset
         chainID
          asset
          balance
          weight
          timestamp
        }
        timestamp
        totalSupply
      }
      symbol
      totalSupply
    }
  }
    `
}
